import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { customerData, orderDetails } from 'src/app/models/customerData';
import { customerListRespose } from 'src/app/models/customerListResponse';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class customerService {
  constructor(private http: HttpClient) {}

  getCustomerList(data: string): Observable<customerListRespose> {
    return this.http
      .get<{
        data: customerListRespose;
      }>(`${environment.base_url}customer?${data}`)
      .pipe(map(res => res.data));
  }

  deleteUser(id: string): Observable<number> {
    return this.http
      .delete<{ statusCode: number }>(`${environment.base_url}customer/${id}`)
      .pipe(map(res => res.statusCode));
  }

  getCustomerById(id: string | null): Observable<customerData> {
    return this.http
      .get<{ data: customerData }>(`${environment.base_url}customer/${id}`)
      .pipe(map(res => res.data));
  }

  addCustomer(data: customerData): Observable<customerData> {
    return this.http
      .post<{ data: customerData }>(`${environment.base_url}customer`, data)
      .pipe(map(res => res.data));
  }

  getOrderDetails(id: string | null, query: string): Observable<orderDetails> {
    return this.http
      .get<{
        data: orderDetails;
      }>(`${environment.base_url}getOrders/${id}?${query}`)
      .pipe(map(res => res.data));
  }

  updateCustomer(
    data: customerData| { isBlocked: boolean },
    id: string
  ): Observable<customerData> {
    return this.http
      .put<{
        data: customerData;
      }>(`${environment.base_url}customer/${id}`, data)
      .pipe(map(res => res.data));
  }

  userTopup(data: { userId: string, amount: number }): Observable<customerData> {
    return this.http
      .post<{ data: customerData }>(`${environment.base_url}rechargeWallet`, data)
      .pipe(map(res => res.data));
  }

  exportCsv(query: string): Observable<Blob> {
    return this.http.get<Blob>(
      `${environment.base_url}customerExport?${query}`,
      { responseType: 'blob' as 'json' }
    );
  }
}
